import type { SVGProps } from 'react';

const SvgCompanyWeTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M8.257 14.373c-.193-.306-.352-.468-.633-.468s-.44.162-.633.468l-.845 1.348c-.317.522-.58.882-1.196.882s-.898-.252-1.197-.954a21.4 21.4 0 0 1-1.108-3.309c-.387-1.565-.563-2.536-.563-3.327 0-.792.246-1.26 1.09-1.421C4.335 7.376 5.9 7.25 7.625 7.25c1.724 0 3.29.126 4.451.342.845.162 1.091.63 1.091 1.42 0 .792-.176 1.763-.563 3.328a21.4 21.4 0 0 1-1.108 3.31c-.3.7-.58.953-1.197.953-.616 0-.88-.36-1.196-.882zm13.39 1.262c-.598.647-1.724 1.115-3.202 1.115-2.974 0-4.733-2.068-4.733-4.784 0-2.914 2.023-4.64 4.645-4.64 2.34 0 3.888 1.24 3.888 2.913 0 1.583-1.32 2.608-2.815 2.608-.81 0-1.408-.162-1.812-.486-.159-.125-.247-.107-.247.037 0 .593.212 1.097.599 1.492.316.324.915.54 1.478.54.58 0 1.09-.126 1.548-.36s.844-.162 1.073.216c.264.432-.105.99-.422 1.349"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCompanyWeTransfer;
